export const SET_FAQ = 'SET_FAQ';

export const setFaq = (faq) => {
  return {
    type: SET_FAQ,
    payload: faq,
  };
};
